module.exports = __webpack_public_path__ + "static/img/rank_287.c973412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_287.png
// module id = lGgK
// module chunks = 1